module.exports = __webpack_public_path__ + "static/media/14.0cad7604.ogg";